module.exports = __webpack_public_path__ + "img/image_3.61b5144c.png";